const React = require('react');
const { createElement: h } = React;

// Sidebar editor for the Variable node. Replaces the cramped inline editor
// (VariableEditor in WorkflowNode.js) with a roomier labeled form:
//
//   Data type
//   [ String | Integer | Boolean | Date | JSON | Array ]
//
//   Value
//   [ input or textarea depending on type ]
//
//   Mode
//   [ Reset on run ] [ Persist across runs ]
//
function normalizeVariableType(value) {
  var raw = String(value || '').toLowerCase();
  if (raw === 'int' || raw === 'integer' || raw === 'number') return 'int';
  if (raw === 'date') return 'date';
  if (raw === 'bool' || raw === 'boolean') return 'bool';
  if (raw === 'json' || raw === 'object') return 'json';
  if (raw === 'array') return 'array';
  return 'string';
}

function VariableSidebarEditor(props) {
  var paramValues = props.paramValues || {};
  var onParamChange = props.onParamChange || function() {};

  var dataType = normalizeVariableType(paramValues.dataType);
  var rawValue = paramValues.value;
  var isStatic = String(paramValues.retain || 'false') === 'true';
  var isMultiline = dataType === 'json' || dataType === 'array';
  var isBool = dataType === 'bool';
  var boolValue = String(rawValue || '').toLowerCase() === 'true';

  function valueToString(v) {
    if (v === undefined || v === null) return '';
    if (typeof v === 'object') {
      try { return JSON.stringify(v, null, 2); } catch (e) { return ''; }
    }
    return String(v);
  }

  function onTypeChange(nextType) {
    var t = normalizeVariableType(nextType);
    onParamChange('dataType', t);
    var cur = String(paramValues.value || '');
    if (t === 'bool') {
      if (cur !== 'true' && cur !== 'false') onParamChange('value', 'false');
    } else if (t === 'json' && !cur) {
      onParamChange('value', '{}');
    } else if (t === 'array' && !cur) {
      onParamChange('value', '[]');
    }
  }

  return h('div', { className: 'wf-params-form' },
    h('div', { className: 'wf-params-row' },
      h('div', { className: 'wf-params-row-label' }, 'Data type'),
      h('select', {
        className: 'wf-params-input',
        value: dataType,
        onChange: function(e) { onTypeChange(e.target.value); }
      },
        h('option', { value: 'string' }, 'String'),
        h('option', { value: 'int' }, 'Integer'),
        h('option', { value: 'bool' }, 'Boolean'),
        h('option', { value: 'date' }, 'Date'),
        h('option', { value: 'json' }, 'JSON'),
        h('option', { value: 'array' }, 'Array')
      )
    ),
    h('div', { className: 'wf-params-row' },
      h('div', { className: 'wf-params-row-label' }, 'Value'),
      isBool
        ? h('div', { className: 'wf-params-toggle' },
            h('button', {
              type: 'button',
              className: 'wf-params-toggle-btn' + (boolValue ? ' wf-params-toggle-btn-active' : ''),
              onClick: function() { onParamChange('value', 'true'); }
            }, 'True'),
            h('button', {
              type: 'button',
              className: 'wf-params-toggle-btn' + (!boolValue ? ' wf-params-toggle-btn-active' : ''),
              onClick: function() { onParamChange('value', 'false'); }
            }, 'False')
          )
        : isMultiline
          ? h('textarea', {
              className: 'wf-params-input wf-params-textarea wf-params-textarea-mono',
              rows: 6,
              placeholder: dataType === 'array' ? '[]' : '{}',
              value: valueToString(rawValue),
              onChange: function(e) { onParamChange('value', e.target.value); }
            })
          : h('input', {
              className: 'wf-params-input',
              type: dataType === 'date' ? 'datetime-local' : (dataType === 'int' ? 'number' : 'text'),
              placeholder: dataType === 'int' ? '0' : '',
              value: valueToString(rawValue),
              onChange: function(e) { onParamChange('value', e.target.value); }
            })
    ),
    h('div', { className: 'wf-params-row' },
      h('div', { className: 'wf-params-row-label' }, 'Mode'),
      h('div', { className: 'wf-params-toggle' },
        h('button', {
          type: 'button',
          className: 'wf-params-toggle-btn' + (!isStatic ? ' wf-params-toggle-btn-active' : ''),
          onClick: function() { onParamChange('retain', 'false'); }
        }, 'Reset on run'),
        h('button', {
          type: 'button',
          className: 'wf-params-toggle-btn' + (isStatic ? ' wf-params-toggle-btn-active' : ''),
          onClick: function() { onParamChange('retain', 'true'); }
        }, 'Persist')
      )
    )
  );
}

module.exports = VariableSidebarEditor;
